import axios from "axios";
import React, { useEffect, useState } from "react";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import { MenuItem, Select } from "@mui/material";
import { BookmarkAdd, Refresh } from "@mui/icons-material";

function ResearchCard(props) {
  const [cite, setSite] = useState("IEEE");
  const [loading, setLoading] = useState(false);
  let user = JSON.parse(localStorage.getItem("user"));
  function removeHtmlTags(input) {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.body.textContent || "";
  }
  // useEffect(() => {
  //   console.log(
  //     removeHtmlTags(
  //       JSON.parse(
  //         props.notes[props.headCaption][
  //           props.getIndex(props.headCaption, props.caption, props.titleObject)
  //         ].notes
  //       ).blocks[1].data.text
  //     )
  //   );
  // }, [props]);
  // .forEach((block) => {
  //   console.log(block.data.text);
  // })
  const citeInEditor = async () => {
    setLoading(true);
    const payload = {
      text: props.data.citationStyles.bibtex,
      userid: user.id,
      format: cite,
    };
    try {
      const res = await axios.post(
        "https://api.gyanibooks.com/generate_citations/",
        payload
      );
      props.handleCitations((prevCitations) => [...prevCitations, res.data]);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
    props.setSideMenu(false);
  };

  return (
    <div className="max-w-[650px] mx-auto my-5">
      <div className="w-full max-h-[400px] overflow-hidden border-2 p-4 rounded-lg shadow-md bg-white transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg">
        {/* Bookmark Button */}
        <div className="flex items-center justify-between mb-4">
          {/* Select menu */}
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={cite}
            onChange={(e) => setSite(e.target.value)}
            label="Age"
            className="h-[28px]"
          >
            <MenuItem value={"IEEE"}>IEEE</MenuItem>
            <MenuItem value={"Chicago"}>Chicago</MenuItem>
            <MenuItem value={"Harvard"}>Harvard</MenuItem>
            <MenuItem value={"MLA"}>MLA</MenuItem>
            <MenuItem value={"APA"}>APA</MenuItem>
          </Select>
          {props.isBookmarked ? (
            <button className="h-[28px] flex flex-row justify-start items-center px-2 gap-1 rounded-[6px] hover:bg-blue-700 text-[12px] font-[600] leading-[14px] text-[#ffffff] bg-blue-500 outline-none focus:outline-4 focus:outline-[#31D0AA]">
              <BookmarkIcon
                onClick={props.onsetBookmark}
                color="light"
                fontSize="small"
              />
            </button>
          ) : (
            <button className="h-[28px] flex flex-row justify-start items-center px-2 gap-1 rounded-[6px] hover:bg-blue-700 text-[12px] font-[600] leading-[14px] text-[#ffffff] bg-blue-500 outline-none focus:outline-4 focus:outline-[#31D0AA]">
              <BookmarkAdd
                onClick={props.onsetBookmark}
                color="light"
                fontSize="small"
              />
            </button>
          )}
        </div>

        {/* Title */}
        <div
          className="font-bold text-md mb-2 text-left"
          style={{
            fontSize: "1rem",
            lineHeight: "1.5",
          }}
        >
          {props.data.title}
        </div>

        {/* Authors */}
        <div
          className="text-gray-600 mb-1 overflow-hidden overflow-ellipsis line-clamp-1 italic text-left"
          style={{ fontSize: "0.9rem" }}
          key={props.data.authors.authorId}
        >
          {props.data.authors.map((author, index) => (
            <span className="text-blue-500">
              {author?.name}
              {index !== props.data.authors.length - 1 && ", "}
            </span>
          ))}
          <div
            className="text-blue-500 mb-1 italic"
            style={{ fontSize: "0.9rem" }}
            key={props.data.authors.authorId}
          >
            {props.data.journal?.name},{" "}
            {props.data.journal?.volume &&
              `Volume: ${props.data.journal?.volume}, `}
            Pages: {props.data.journal?.pages}
          </div>
        </div>

        {/* Abstract */}
        <div
          className="border p-1 rounded-md border-gray-300 mb-2 bg-gray-50 text-left"
          style={{ fontSize: "0.9rem" }}
        >
          <div className="text-gray-600 text-ellipsis line-clamp-3">
            {props.data.abstract}
          </div>
        </div>

        <div className="mb-2"></div>

        <div className="flex justify-between items-center">
          <div
            className="overflow-hidden whitespace-nowrap overflow-ellipsis line-clamp-1 text-gray-500 text-[12px] leading-[14px] text-left" // Align text to the left
            style={{ fontSize: "0.9rem" }}
          >
            <div className="text-blue-500">
              Cited By {props.data.citationCount}
            </div>
          </div>
          <div className="flex gap-2 mt-2">
            <button
              className="bg-blue-500 rounded-2xl py-2 px-4 text-white text-[15px] font-[600] leading-[14px]"
              onClick={() => citeInEditor()}
            >
              <>{loading && <Refresh className="!animate-spin" />}</>
              Cite
            </button>
            <button
              className="border-[1px] border-blue-500 rounded-2xl py-2 px-2 text-black text-[12px] font-[600] leading-[14px]"
              onClick={props.onViewInNewTab}
            >
              View in a new Tab
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResearchCard;
